import React from 'react';
import { ModalsKeys } from 'global';
import { useModal } from 'hooks/useModal';
import { FormInput } from 'components/form';
import { Box, Button, Stack } from '@mui/material';

interface Props {
  externalDealId: string;
  onExternalDealIdChange: (id: string) => void;
}

export const SyncDealInfo = ({ externalDealId, onExternalDealIdChange }: Props) => {
  const { handleOpen: handleOpenDealSyncModal } = useModal(ModalsKeys.SyncDealInfoDialog);

  return (
    <Stack alignItems="center" gap="1rem" direction="row">
      <FormInput
        variant="outlined"
        value={externalDealId}
        label="External Deal Number"
        style={{ maxWidth: '20rem' }}
        placeholder="Enter Deal Number"
        onChange={onExternalDealIdChange}
      />

      <Box>
        <Button variant="outlined" onClick={() => handleOpenDealSyncModal(ModalsKeys.SyncDealInfoDialog)}>
          Sync Deal Information
        </Button>
      </Box>
    </Stack>
  );
};
